export default function isTest() {
  return process.env.NODE_ENV === 'test'
}

export function isNonCommonUiTest() {
  return isTest() && process.env.npm_package_name !== '@purecars/ui'
}
